import React, { useState, useEffect, useContext } from 'react';
import { Typography, Grid, Button, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import CampanhaCard from '../../components/Campanhas/CampanhaCard';
import { listarCampanhas, listarCampanhasPorInstituicao } from '../../services/campanhaService';
import { AuthContext } from '../../contexts/AuthContext';

const ListaCampanhasPage = () => {
  const [campanhas, setCampanhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Obtenha o usuário logado do contexto de autenticação
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchCampanhas = async () => {
      try {
        setLoading(true);

        console.log('Usuário logado:', user);

        if (user) {
          let data;
          if (user.tipo === 'admin') {
            // Se o usuário for admin, listar todas as campanhas
            data = await listarCampanhas();
          } else if (user.instituicaoId) {
            // Se o usuário for de uma instituição, listar campanhas da instituição
            data = await listarCampanhasPorInstituicao(user.instituicaoId);
          } else {
            setError('Usuário não possui instituição associada.');
            return;
          }

          // Ajuste conforme a estrutura dos dados retornados
          setCampanhas(data.campanhas || data);
        } else {
          setError('Usuário não encontrado. Por favor, faça login novamente.');
        }
      } catch (error) {
        console.error('Erro ao buscar campanhas:', error);
        setError('Não foi possível carregar as campanhas. Por favor, tente novamente.');
      } finally {
        setLoading(false);
      }
    };

    fetchCampanhas();
  }, [user]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <div>
      {/* Botão de Voltar ao Dashboard */}
      <Button
        component={Link}
        to="/dashboard"
        variant="outlined"
        color="secondary"
        sx={{ mb: 2 }}
      >
        Voltar ao Dashboard
      </Button>

      <Typography variant="h4" gutterBottom>
        Campanhas
      </Typography>

      <Button
        component={Link}
        to="/campanhas/criar"
        variant="contained"
        color="primary"
        sx={{ mb: 2, ml: 2 }}
      >
        Criar Nova Campanha
      </Button>

      <Grid container spacing={3}>
        {campanhas.map((campanha) => (
          <Grid item key={campanha.id} xs={12} sm={6} md={4}>
            <CampanhaCard campanha={campanha} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ListaCampanhasPage;
